
import {ElLoading} from "element-plus";

type column = {
    prop: String;
    label: String;
    width: Number;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof partsFormType;
let columnList: Array<column> = [
    // {
    //     prop: "ordersn",
    //     label: "单据编号",
    //     width: 75,
    // },
    {
        prop: "create_time",
        label: "开单时间",
        width: 75,
    },
    {
        prop: "order_message_text",
        label: "接车人",
        width: 75,
    },
    {
        prop: "settlement_time_text",
        label: "结算时间",
        width: 75,
    },
    {
        prop: "settlementperson_text",
        label: "结算人",
        width: 75,
    },
    {
        prop: "order_offer_price",
        label: "报价金额",
        width: 75,
    },
    {
        prop: "price",
        label: "结算金额",
        width: 75,
    },
    {
        prop: "return_price",
        label: "待回款",
        width: 75,
    },
    {
        prop: "order_crd_code_text",
        label: "车牌号码",
        width: 75,
    },
    {
        prop: "user_id",
        label: "会员号",
        width: 75,
    },
    {
        prop: "order_message_give_text",
        label: "送修人",
        width: 75,
    },
    {
        prop: "basicset_name",
        label: "服务类型",
        width: 75,
    },
];
const offerColumn: Array<column> = [
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    },
];
const projectColumn: Array<column> = [
    {
        prop: "project_name",
        label: "维修项目报价",
        width: 80,
    },
    ...offerColumn,
];
const partsColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件报价",
        width: 80,
    },
    {
        prop: "supplier_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "salesman_id_name",
        label: "销售人",
        width: 80,
    },
    {
        prop: "builders_name",
        label: "施工人",
        width: 80,
    },
    {
        prop: "num",
        label: "数量",
        width: 80,
    },
    {
        prop: "quoted_price",
        label: "报价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
    {
        prop: "reappearance_type_id_name",
        label: "返现方案",
        width: 80,
    },
    {
        prop: "output_value",
        label: "产值",
        width: 80,
    }
];
const mountingsCostColumn: Array<column> = [
    {
        prop: "mountings_name",
        label: "配件成本",
        width: 80,
    },
    {
        prop: "collar_num",
        label: "领料",
        width: 80,
    },
    {
        prop: "retreat_num",
        label: "退料",
        width: 80,
    },
    {
        prop: "use_num",
        label: "用量",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "cost",
        label: "成本价",
        width: 80,
    },
    {
        prop: "price",
        label: "金额",
        width: 80,
    },
];
const elseCostColumn: Array<column> = [
    {
        prop: "othercosts_name",
        label: "其他成本",
        width: 80,
    },
    {
        prop: "supplier_id_name",
        label: "供应商",
        width: 80,
    },
    {
        prop: "cpayment_text",
        label: "生成应付款",
        width: 80,
    },
    {
        prop: "branch_id_name",
        label: "承担部门",
        width: 80,
    },
    {
        prop: "othercosts_costprice",
        label: "金额",
        width: 80,
    },
];
const settlementColumn: Array<column> = [
    {
        prop: "pay_name",
        label: "工单结算",
        width: 80,
    },
    {
        prop: "pay_type_name",
        label: "支付方式",
        width: 80,
    },
    {
        prop: "pay_price",
        label: "金额",
        width: 80,
    },
    {
        prop: "pay_ctime",
        label: "时间",
        width: 80,
    },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList,
    partsStockExport,
    workListExport,
    getOrderCarRepairunit,
    purchasePayTotal,
    removeBatchPayListPost,
    addBatchPayListPost,
    removeBatchPayBackList,
    addBatchPayBackList,
    orderBatchBackList,
    getAllPartnerList,
    getOrderCarOrderinfo,
} from "@/api/http";



import {Request} from '@/api/request';
import { validateInput, validateClass } from "@/assets/js/formRules";
import { partsFormType } from "@/assets/types/common";
import { useRoute, useRouter } from 'vue-router'
import {getFirstNowLastDay} from "@/api/date";
export default defineComponent({
    name: "workList",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(['工单应收']);
   
        const headClass = inject("headClass");
        //批量付款专区
        let batchPayList = reactive([]),
            batchDialog_show = ref(false),
            dialogFormVisible = ref(false),
            dialogTable = ref([] as Array<any>),
            orderDetail = ref({} as any),
            batchForm = reactive({
                batch_number:"",
                return_price:"",
                price:"",
                pay_time:new Date(),
                pay_type:'',
                desc:''
            }),
            removeBatchList = reactive([]),
            payTotalClick = (()=>{
                batchDialog_show.value = true;
            }),
            batch_submit = (()=>{
                let date = Math.floor(batchForm.pay_time.getTime()/1000);
                let data = {
                    pay_time:date,
                    pay_type:batchForm.pay_type,
                    desc:batchForm.desc
                }
                loading.value = true;
                orderBatchBackList(data).then(()=>{
                    loading.value = false;
                    batchDialog_show.value = false;
                    getTableData()
                });
            }),
            removeClick = (()=>{
                if (removeBatchList.length==0){
                    alert('请选择数据');
                    return
                }
                let dataArr:any = [];
                removeBatchList.forEach((datum: any) => {
                    dataArr.push(datum.order_id);
                });
                let data = {
                    ids:dataArr.join(",")
                };
                removeBatchPayBackList(data).then((res:any)=>{
                    getTableData()
                });
            }),
            addBatchPayList = (()=>{
                if (batchPayList.length==0){
                    alert('请选择数据');
                    return
                }
                let dataArr:any = [];
                batchPayList.forEach((datum: any) => {
                    dataArr.push(datum.order_id);
                });
                let data = {
                    ids:dataArr.join(",")
                };
                addBatchPayBackList(data).then((res:any)=>{
                    getTableData()
                });
            }),
            // 点击单据编号触发
            getOrderCarinfo = (item: any) => {
                if (item.order_id<=0){
                    return;
                }
                getOrderCarOrderinfo({order_id: item.order_id}).then((res: any) => {
                    if (res.status == 200) {
                        dialogFormVisible.value = true;
                        console.log("444");
                        let info = res.content.list;
                        if (info) {
                            let arr = [[
                                '单据编号',
                                info.ordersn,
                                '状态',
                                info.orderstatustext,
                                '开单时间',
                                info.create_time_text,
                                '结算时间',
                                info.settlement_time_text,
                            ], [
                                '服务类型',
                                info.basicset_id_name,
                                '接车人',
                                info.meet_vehicle_id_name,
                                '报价金额',
                                info.offer_price,
                                '结算金额',
                                info.settlement_pirce,
                            ], [
                                '车牌号码',
                                info.car_code,
                                '品牌车型',
                                info.series_name,
                                '进厂里程',
                                info.mitplant,
                                '是否返修',
                                info.is_rework_text,
                            ], [
                                '送修人',
                                info.send_for_repair,
                                '手机号码',
                                info.send_for_repair_phone,
                                '会员号',
                                info.user_id,
                                '昵称',
                                info.user_nickname,
                            ], [
                                '保险公司',
                                info.cicompany_id_name,
                                '送修单位',
                                info.units_id_name,
                                '合作方',
                                info.partner_id_name,
                                '工单备注',
                                info.settlement_notes,
                            ]];
                            dialogTable.value = arr;
                            orderDetail.value = res.content.list;
                        }
                    }
                });
            },
            getSummariesDia = (param: any, type: number): Array<string> => {
                const {columns, data} = param;
                const sums: any = [];
                const propArr = [
                    "othercosts_costprice",
                    "price",
                    "output_value",
                    "pay_price",
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        switch (type) {
                            // 维修项目报价合计
                            case 1:
                                if (column.property == "price") {
                                    sums[index] = orderDetail.value.project_sum_quoted_price;
                                } else {
                                    sums[index] = orderDetail.value.project_sum_output_value;
                                }
                                break;
                            // 配件报价合计
                            case 2:
                                if (column.property == "output_value") {
                                    sums[index] = orderDetail.value.mountings_sum_output_value;
                                } else {
                                    sums[index] = orderDetail.value.mountings_sum_quoted_price;
                                }

                                break;
                            // 配件成本合计
                            case 3:
                                sums[index] = orderDetail.value.mountings_cost_price;
                                break;
                            // 其他成本合计
                            case 4:
                                sums[index] = orderDetail.value.else_cost_price;
                                break;
                            // 工单结算合计
                            case 5:
                                sums[index] = orderDetail.value.settlement_pirce;
                                break;
                        }
                        sums[index] = `¥${sums[index]}`;
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            handleSelectionChange = ((selection:any)=>{
                batchPayList = [];
                removeBatchList = [];
                if (NavIndex.value==0){
                    batchPayList = selection;
                }else if(NavIndex.value==2){
                    removeBatchList = selection;
                }
            });
        let pageSize = ref(10),
            currentPage = ref(1),
            NavIndex = ref(-1),
            tableData = ref([] as Array<any>),
            total = ref(0),
            loading = ref(true),
            type =  ref(''),
            priceTotal = ref(0),
            returnTotal = ref(0),
            route:any = useRoute(),
            Router:any = useRouter(),
            selectList = ref({
                type: [],
                zf: [],
                staff: [],
                branch: [],
                repairunit_data:[],
                partner_data:[]
            }),
            form_rules:any = {
                //fixed_name fixed_price time branch_id fixed_type
				fixed_name: {required: true, message: '必填', trigger: 'blur'},
                fixed_price: {required: true, message: '必填', trigger: 'blur'},
                time: {required: true, message: '必填', trigger: 'blur'},
                branch_id: {required: true, message: '必填', trigger: 'blur'},
                fixed_type: {required: true, message: '必填', trigger: 'blur'},
			},
            remote_loading = ref(false),
            screenParameter = ref({
                type: 2,
                search: '',
                start_time: null,
                end_time: null,
                page: currentPage.value,
                pagesize: pageSize.value,
                time:null,
                units_id:'',
                batch_pay:0,
                partner_id:''
            } as any),
            dialog_model = ref(''),
            dialogTitle = ref("新增配件"),
            dialog_index = 0,
            dialog_load = ref(false),
            formRef = ref(null),
            form = ref({} as any),
            commissionType = ref(["固定金额", "业绩比例", "毛利比例"]),
            isEdit = ref(false),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入配件名称', value, callback);
                        },
                        trigger: "change",
                    },
                ],
                class: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: undefined,
                            callback: Function
                        ) => {
                            validateClass(rule, callback, form);
                        },
                        trigger: "change",
                    },
                ],
				cost_price: [{required: true,message: '必填',trigger: "change"}],
				mountings_type_pid: [{required: true,message: '必填',trigger: "change"}],
                price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput('请输入成本价', value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });
        let handleSizeChange = (size: number): void => {
                pageSize.value = size;
                getTableData();
            },
            handleCurrentChange = (page: number): void => {
                currentPage.value = page;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                Request.axiosInstance({
                    url: 'adminapi/Bookkeeping/workList',
                    data: {
                        ...screenParameter.value,
                        page: currentPage.value,
                        pagesize: pageSize.value
                    }
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                    priceTotal.value = res.content.price_total;
                    returnTotal.value = res.content.return_total;
                    if (NavIndex.value==2){
                        batchForm.batch_number = res?.content?.total || 0;
                        batchForm.return_price = res?.content?.return_total || 0;
                        batchForm.price = res?.content?.price_total || 0;
                    }
                })

            },
            getSummaries = (param: any): Array<string> => {
                const {columns, data} = param;
                const sums: any = [];
                const propArr = [
                    "price",
                    "return_price"
                ];
                columns.forEach((column: any, index: number) => {
                    if (index === 0) {
                        sums[index] = "合计";
                        return;
                    }
                    const values = data.map((item: any) =>
                        Number(item[column.property])
                    );
                    if (
                        propArr.findIndex((item: any) => {
                            return item == column.property;
                        }) > -1
                    ) {
                        // 增加合计项
                        if (column.property == "price") {
                            sums[index] = priceTotal.value;
                        }
                        if (column.property == "return_price") {
                            sums[index] = returnTotal.value;
                        }
                    } else {
                        sums[index] = "";
                    }
                });
                return sums;
            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getSelectList(data).then((res: any) => {
                    Object.assign(selectList.value, res?.content || {});
                    remote_loading.value = false;
                });
            },
            selectChange = (e: any, key: string): void => {
                resetTableData();
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({ search: e });
            },
            formSelectChange = (e: number) => {
                getSelectData({ type_pid: e });
                form.value.mountings_type_id = null;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            screenChange = ( e: any, key: string): void => {
	
			   if (key == "time") {
                    screenParameter.value["start_time"] = e ?  Math.floor(new Date(e[0]).getTime()/1000) : null
                    screenParameter.value["end_time"] = e? Math.floor((new Date(e[1]).getTime()+24*60*60*1000-1)/1000) : null
               }
    
                resetTableData();
			},
            exportChange = () => {
                const loading = ElLoading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',
                });
    
                workListExport(screenParameter.value).then((res: any) => {
                    loading.close();
                    if (res.status == 200) {
                        const url = res.content;
                        window.open(url);
                    }
                }).catch(()=>{
                    loading.close();
                });
            },
            resetTableData = (()=>{
                currentPage.value = 1;
                getTableData();
            }) ,
            _form_submit = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (!valid)  return

                    dialog_load.value = true
                    Request.axiosInstance({
                        url: dialog_model.value == 'add' ? 'adminapi/Bookkeeping/fixedCreate' : 'adminapi/Bookkeeping/fixedEdit',
                        data: form.value
                    }).then((res) => {
                        dialog_load.value = false
                        if(res.status != 202) return
                        dialog_model.value = ''
                        getTableData()
                    })
                });
            },

            _option = (url: string , data: any) => {
				Router.push({
					path: url,
					query: data
				})
			};


        onMounted(() => {
            
            Promise.all([
                Request.axiosInstance({
                    url: 'adminapi/Bookkeeping/expenditureType',
                    data: {status: 1}
                }),
                Request.axiosInstance({
                    url: 'adminapi/Basicset/totalList',
                    data: {basicset_type: 3}
                }),
                Request.axiosInstance({
                    url: 'adminapi/OrderCar/constructors',
                    data: {}
                }),
                
            ]).then((res: any) => {
                console.log(res)
                selectList.value.type = res[0]?.content?.list
                selectList.value.zf = res[1]?.content?.list
                selectList.value.staff = res[2]?.content?.staff
                selectList.value.branch = res[2]?.content?.branch
            });
            getOrderCarRepairunit({}).then((res: any) => {
                selectList.value.repairunit_data = res?.content?.list || [];
            });
            getAllPartnerList({}).then((res:any)=>{
                selectList.value.partner_data = res?.content?.list || [];
            });
            //getTableData();
            NavIndex.value = 0

        });
        watch(NavIndex, (newval: any, oldval: any) => {
            tableData.value = []
            if(newval == 0)
            {
                screenParameter.value = {
                    type: 2,
                    search: '',
                    start_time: null,
                    end_time: null,
                    page: currentPage.value,
                    pagesize: pageSize.value,
                    time:null,
                    units_id:'',
                    batch_pay: 0
                }
            }
            else if(newval == 2)
            {
                screenParameter.value = {
                    batch_pay: 1
                }
            }
        
            getTableData()
        }),
        watch(dialog_model, (newval: any, oldval: any) => {
            if(newval == 'add'){
                form.value = {
                    time: null,
                    fixed_name: null,
                    fixed_price: null,
                    branch_id: null,
                    fixed_desc: null,
                    start_text: null,
                    end_text: null,
                    fixed_type: null,
                    expenditure_time: null,
                    admin_id: null,
                    pay_type: null,
                    expenditure_phone: null,
                    expenditure_payer: null,
                }
                dialog_load.value = false
            }
            else if(newval == 'edit')
            {
                form.value = ({
                    fixed_id: tableData.value[dialog_index].fixed_id,
                    time: [new Date(tableData.value[dialog_index].start_text), new Date(tableData.value[dialog_index].end_text)],
                    fixed_name: tableData.value[dialog_index].fixed_name,
                    fixed_price: tableData.value[dialog_index].fixed_price,
                    branch_id: tableData.value[dialog_index].branch_id,
                    fixed_desc: tableData.value[dialog_index].fixed_desc,
                    start_text: tableData.value[dialog_index].start_text,
                    end_text: tableData.value[dialog_index].end_text,
                    fixed_type: tableData.value[dialog_index].fixed_type,
                    expenditure_time: null,
                    admin_id: null,
                    pay_type: null,
                    expenditure_phone: null,
                    expenditure_payer: null,
                } as any)
                dialog_load.value = false
            }

        })

    

        return {
            columnList,
            getSummaries,
            dialogFormVisible,
            dialogTable,
            orderDetail,
            getSummariesDia,
            projectColumn,
            partsColumn,
            mountingsCostColumn,
            elseCostColumn,
            settlementColumn,
            getOrderCarinfo,
            headClass,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            selectList,
            remote_loading,
            dialogTitle,
            formRef,
            form,
            commissionType,
            isEdit,
            rules,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            remoteBrand,
            formSelectChange,
            bonusSelectChange,
            type,
            _option,
            screenParameter,
            dialog_model,
            screenChange,
            dialog_index,
            _form_submit,
            form_rules,
            dialog_load,
            exportChange,
            removeClick,
            handleSelectionChange,
            addBatchPayList,
            batchPayList,
            payTotalClick,
            batchForm,
            batch_submit,
            NavIndex,
            batchDialog_show,
            resetTableData
        };
    },
});
